"use strict";
/* tslint:disable */
var TBasePurchases = (function () {
    var api = {};
    api.buildInner = function () { };
    api.createLoader = function (statusClass) {
        if (statusClass !== "emphasis") {
            return '';
        }
        return `
            <div class="loading" >
                ${TSlipShared.createLoader()}
            </div>`;
    };
    api.createLinesList = function (mode, purchase, context) {
        if (context.isSingle && !IsUKBetSlip) {
            return '';
        }
        return this.createLinesListInner(mode, purchase.getSelectionsToBuild(), context);
    };
    api.createBetsList = function (mode, purchase, context) {
        var bets = purchase.getBets ? purchase.getBets() : purchase.Bets;
        return this.createBetsListInner(mode, bets, context, purchase);
    };
    api.createLinesListInner = function () { };
    api.createBetsListInner = function () { };
    api.createBetTitle = function (bet) {
        if (bet.StatusText !== $dict.bs("DepositOverMaxBet") &&
            bet.StatusText !== $dict.bs("BetNotAccepted") &&
            !bet.BetID) {
            return '';
        }
        if (UseAustralianHorseRacingView && (bet.StatusText === $dict.bs("DepositOverMaxBet")) &&
            ([11, 12, 21].indexOf(bet.BetType) >= 0)) {
            return '';
        }
        var title = bet.getBetTitle();
        if (title && bet.StatusText !== $dict.bs("DepositOverMaxBet")) {
            return `<strong class="bet_status ${bet.getStatusClass()}">${title}</strong> | `;
        }
        return '';
    };
    api.createBetDeposit = function (bet, context) {
        var updated = bet.isDepositUpdated(context) ? "updated" : "";
        return `<span class="${updated}" data-uat="bet-purchase-stake">${bet.getDeposit(context)}</span>`;
    };
    api.createFreeBetStake = function (bet, context) {
        if (!bet.FreeBetStake) {
            return "";
        }
        var phrase = bet.FreeBet && bet.FreeBet.IsRiskFreeBet ? "RiskFreeBetDeposit" : "FreeBetDeposit";
        return `<br/><strong>${$dict.bs(phrase)}:</strong><span>${Bets.formatCurrencyStake(bet.FreeBetStake, BetSlip.UserCurrencyCode)}</span>`;
    };
    api.createBetOdds = function (mode, bet, context) {
        if (bet.BetsCount > 1) {
            return '';
        }
        if (bet.Selection) {
            return TSlipShared.createPickLineOdds(mode, bet.Selection, context);
        }
        var updated = bet.OddsUpdated ? "updated" : "", odds = bet.getOdds(context);
        return `<span class="${updated} ${Odds.getAsianViewClassList(odds)}" data-uat="bet-odds">${$dict.bs("OddsSeparator")} ${odds}</span>`;
    };
    api.createNewOfferActions = function () { };
    api.buildPick = function (mode, selection, context, selections, bet, purchase) {
        if (Purchases.isSingleBet(purchase, bet, context)) {
            context.shouldShowEW = false;
            selection = bet.Selection;
            var selectionType = BetSlipUtil.getSelectionType(selection);
            var __html = "";
            __html += TSelections[selectionType].buildPick(mode, selection, context, selections);
            return __html;
        }
        else {
            return bet.getDescription(context);
        }
    };
    api.buildComboBonusInfo = function (bet) {
        if (Purchases.hasComboBonus(bet)) {
            return TComboBonusPresenter.buildView.buildPurchase(bet.VariationType);
        }
        return '';
    };
    api.buildDescription = function (mode, selection, context, selections, bet, purchase) {
        if (Purchases.isSingleBet(purchase, bet, context)) {
            selection = bet.Selection;
            var selectionType = BetSlipUtil.getSelectionType(selection);
            return TSelections[selectionType].buildDescription(mode, selection, context, selections);
        }
        return '';
    };
    api.buildLoyaltyPoints = function (bet) {
        if (ConfigurationLoyaltyProgram.isInitilized) {
            var isEachWayBet = BetSlip.isEachWayBetForLoyaltyPoints(bet);
            return TLoyaltyPointsPresenter.buildLoyaltyPointsInReceipt(bet, isEachWayBet);
        }
        return '';
    };
    api.buildTaxOnDeposit = function (bet) {
        if (UserInfo.TaxProvider.isTurnoverTaxEnabledBeforePlacing()) {
            var deductedDeposit = UserInfo.TaxProvider.applyTaxToDeposit(bet.getTotalDeposit());
            if (typeof UserInfo.TaxProvider.formatDeposit === "function") {
                deductedDeposit = UserInfo.TaxProvider.formatDeposit(deductedDeposit);
            }
            return `
                <div class="betSlip-taxInfo-msg tax-info-message" data-uat="tax-info-message">
                    ${UserInfo.TaxProvider.getTurnOverMessage(UserInfo.TaxProvider.TaxInfo.TurnOverTax, $dict.bs, "TurnOverMessageLong")}
                </div>
                <div>${deductedDeposit.toFixed(2)}</div>
            `;
        }
        return '';
    };
    return api;
}());
window.TBasePurchases = TBasePurchases;
//# sourceMappingURL=TBasePurchases.js.map